export type AuthSecretProps = { accessToken: string, refreshToken: string, user: any }
export type AuthReducerPros = { type: string, secret: AuthSecretProps, token: any }

const storageName = 'msbcc'

//
// The session as plain JSON (operator, 16.10.2026). It used to be encrypted
// with the key of the reset codes — that key went to the browser for this, and
// encrypting with a key the page itself carries protects nothing. An entry
// still written the old way does not read and means signing in once more.
//
const getSecret = () => {
  const secret = sessionStorage.getItem(storageName)
  if (typeof secret !== 'string' || secret[0] !== '{') return null
  try {
    return JSON.parse(secret)
  } catch {
    return null
  }
}

const setSecret = (secret: AuthSecretProps) => {
  sessionStorage.setItem(storageName, JSON.stringify(secret))
}

const removeSecret = () => {
  sessionStorage.removeItem(storageName)
}

const updateLocalAccessToken = (token: string) => {
  let secret = getSecret()
  if (secret) {
    secret.accessToken = token
    setSecret(secret)
  }
}

const updateLocalUser = (user: any) => {
  let secret = getSecret()
  if (secret) {
    secret.user = user
    setSecret(secret)
  }
}

const TokenService = {
  getSecret,
  setSecret,
  removeSecret,
  updateLocalAccessToken,
  updateLocalUser,
}

export default TokenService